
import { info } from "autoprefixer";
import { Component } from "react";



class Projects extends Component{
    render(){
        const projects = [
            {
                name:"Beautyness",
                info:"I did this Project to learn and improve my web design skills.The UI was designed By Gandom Engineering Group",
                link:"https://amir-kht.github.io/beautyness/"
        
            },
            {
                name:"Pong",
                info:"This ping pong project is a game created with Canvas and JavaScript. it controlled by the players with [w,a] and [up,down] keys",
                link:"https://amir-kht.github.io/pong/"
        
            },
            {
                name:"Bouncing Text",
                info:"Its a Canvas project that animates text bouncing around the screen.Users can control the speed, add more text, and clear texts and ....",
                link:"https://amir-kht.github.io/bouncing-text/"
        
            },
            {
                name:"F1 Simulator",
                info:"F1 Simulator is a simple simulation project built with Canvas and JavaScript, designed for users to watch the Formula 1 race.",
                link:"https://amir-kht.github.io/f1-simulator/"
        
            }
        ]
        return(

            <div id="projects" className="flex justify-around w-full pt-10 flex-wrap">
                
                    {projects.map(i=>(

                        <div id="project" key={i} className="flex flex-col w-80 h-52 rounded-xl mt-10 shadow-lg">
                            <span id="project-name" className="text-xl font-bold pt-8 pl-8">{i.name}</span>
                            <span id="project-info" className="w-5/6 pl-8 pt-3 min-h-24 text-sm ">{i.info}</span>
                            <span id="project-link" className="pl-8 pt-2 w-2/5 font-bold relative hover:underline cursor-pointer"><a href={i.link}>View Project</a></span>
                        </div>
                    ))
                    }
            </div>
        )
    }
}

export default Projects;